<script setup lang="ts">
import { computed } from 'vue'

import { Author } from './Author'

const props = withDefaults(
  defineProps<{
    hasMiddleAuthors?: boolean,
    lastAuthor?: Author | null
  }>(),
  {
    hasMiddleAuthors: false,
    lastAuthor: null
  }
)

const authorsClasses = computed(() => {
  return {
    flex: true,
    'items-baseline': true,
    'flex-wrap': props.hasMiddleAuthors,
    'flex-col': !props.hasMiddleAuthors,
    'gap-y-0.1': props.hasMiddleAuthors,
    'gap-y-0.5': props.hasMiddleAuthors,
    'ml-2': !(props.hasMiddleAuthors || props.lastAuthor),
    'mr-2': true
  }
})

</script>

<template>
  <div :class="authorsClasses">
    <slot name="first-author" />
    <slot name="middle-authors" />
    <slot name="last-author" />
  </div>
</template>
